export default __webpack_public_path__ + "static/media/838.0a443c6f.png";